import React from 'react';
import styled from 'styled-components';
import Tooltip from '@splunk/react-ui/Tooltip';
import { variables } from '@splunk/themes';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../../../common/theme/ThemeProvider';
import { react2angular } from 'react2angular';
import CircleSmall from '@splunk/react-icons/CircleSmall';

const DotIcon = styled(CircleSmall)`
    color: ${variables.statusColorMedium};
`;

const EntityTabNotificationIndicator: React.FC = () => {
    const themeKey = useLegacyThemeServiceKey();

    return (
        <ThemeProvider colorScheme={themeKey}>
            <Tooltip content={'Entity type updated'} defaultPlacement="below">
                <DotIcon variant="filled" />
            </Tooltip>
        </ThemeProvider>
    );
};

export const entityTabNotificationIndicator = react2angular(EntityTabNotificationIndicator);
